var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNorecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 163,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 8.0829C76.1632 3.08119 86.8368 3.08119 95.5 8.0829L138.081 32.6671C146.744 37.6688 152.081 46.9124 152.081 56.9158V106.084C152.081 116.088 146.744 125.331 138.081 130.333L95.5 154.917C86.8368 159.919 76.1632 159.919 67.5 154.917L24.9189 130.333C16.2557 125.331 10.9189 116.088 10.9189 106.084V56.9158C10.9189 46.9124 16.2557 37.6688 24.9189 32.6671L67.5 8.0829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13.3301C77.641 10.6506 83.359 10.6506 88 13.3301L135.787 40.9199C140.428 43.5994 143.287 48.5513 143.287 53.9103V109.09C143.287 114.449 140.428 119.401 135.787 122.08L88 149.67C83.359 152.349 77.641 152.349 73 149.67L25.2132 122.08C20.5721 119.401 17.7132 114.449 17.7132 109.09V53.9103C17.7132 48.5513 20.5721 43.5994 25.2132 40.9199L73 13.3301Z",
    fill: "url(#paint0_linear_1088_16444)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16.7528C78.0222 14.4306 82.9778 14.4306 87 16.7528L133.323 43.4972C137.345 45.8195 139.823 50.1111 139.823 54.7556V108.244C139.823 112.889 137.345 117.181 133.323 119.503L87 146.247C82.9778 148.569 78.0222 148.569 74 146.247L27.6773 119.503C23.655 117.181 21.1773 112.889 21.1773 108.244V54.7556C21.1773 50.1111 23.655 45.8195 27.6773 43.4972L74 16.7528Z",
    fill: "url(#paint1_linear_1088_16444)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2503 78.0208C82.4161 78.0208 73.6045 86.8358 73.6045 97.6667C73.6045 108.498 82.4161 117.312 93.2503 117.312C104.085 117.312 112.896 108.498 112.896 97.6667C112.896 86.8358 104.085 78.0208 93.2503 78.0208ZM99.9299 100.229H93.2503C91.8358 100.229 90.6878 99.0812 90.6878 97.6667V90.7138C90.6878 89.2993 91.8358 88.1513 93.2503 88.1513C94.6648 88.1513 95.8128 89.2993 95.8128 90.7138V95.1042H99.9299C101.344 95.1042 102.492 96.2522 102.492 97.6667C102.492 99.0812 101.344 100.229 99.9299 100.229ZM96.667 50.6875H62.5003C57.307 50.6875 53.1045 54.89 53.1045 60.0833V104.5C53.1045 109.693 57.307 113.896 62.5003 113.896H74.5953C70.7687 109.557 68.4795 103.885 68.4795 97.6667C68.4795 84 79.5837 72.8958 93.2503 72.8958C97.9653 72.8958 102.339 74.1942 106.063 76.5175V60.0833C106.063 54.89 101.86 50.6875 96.667 50.6875ZM69.3337 86.5625H65.917C64.5162 86.5625 63.3545 85.4008 63.3545 84C63.3545 82.5992 64.5162 81.4375 65.917 81.4375H69.3337C70.7345 81.4375 71.8962 82.5992 71.8962 84C71.8962 85.4008 70.7345 86.5625 69.3337 86.5625ZM79.5837 76.3125H65.917C64.5162 76.3125 63.3545 75.1508 63.3545 73.75C63.3545 72.3492 64.5162 71.1875 65.917 71.1875H79.5837C80.9845 71.1875 82.1462 72.3492 82.1462 73.75C82.1462 75.1508 80.9845 76.3125 79.5837 76.3125ZM93.2503 66.0625H65.917C64.5162 66.0625 63.3545 64.9008 63.3545 63.5C63.3545 62.0992 64.5162 60.9375 65.917 60.9375H93.2503C94.6512 60.9375 95.8128 62.0992 95.8128 63.5C95.8128 64.9008 94.6512 66.0625 93.2503 66.0625Z",
    fill: "url(#paint2_linear_1088_16444)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1088_16444",
    x1: 80.5,
    y1: 9,
    x2: 80.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1088_16444",
    x1: 80.5,
    y1: 13,
    x2: 80.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5B0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1088_16444",
    x1: 83.0003,
    y1: 50.6875,
    x2: 83.0003,
    y2: 117.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNorecord);
export default __webpack_public_path__ + "static/media/icon_norecord.9dcb339ff56e563a70546d8be934b87b.svg";
export { ForwardRef as ReactComponent };